/*global jQuery*/
(function ($) {
    'use strict';

    $.fn.topVideoDailyMotion = function (option/*, varArgs*/) {
        var args = Array.prototype.slice.call(arguments, 1);

        return this.each(function () {
            var $element = $(this);
            var ctrl = $element.data('topVideoDailyMotion');

            if (!ctrl) {
                var opts = $.extend({},
                    $.fn.topVideoDailyMotion.defaults,
                    typeof option === 'object' && option
                );

                $element.data('topVideoDailyMotion', (ctrl = new TopVideoDailyMotion(this, opts)));
            }

            if (typeof option === 'string') {
                ctrl[option].apply(ctrl, args);
            }
        });
    };

    $.fn.topVideoDailyMotion.defaults = {
        onEnded: null,
        onReady: null
    };

    function TopVideoDailyMotion(element, options) {
        this.init(element, options);
    }

    TopVideoDailyMotion.lastUid = 0;

    TopVideoDailyMotion.prototype = {
        constructor: TopVideoDailyMotion,

        // Properties
        uid: 0, // Unique id attached to each top video dailymotion instance
        player: null,
        pending: null,

        // Methods
        /**
         * @private
         * @param {jQuery} element
         * @param {object} options
         */
        init: function (element, options) {
            this.uid = TopVideoDailyMotion.lastUid++;
            this.options = options;
            this.$element = $(element);
            this.onEnded = options.onEnded ? [options.onEnded] : [];
            this.onReady = options.onReady ? [options.onReady] : [];
            this.pending = {mute: false, play: false};

            this._onDailyMotionEnd = this._onDailyMotionEnd.bind(this);
            this._onPlayerReady = this._onPlayerReady.bind(this);

            hpDailyMotion.apiReady().then(this._postInit.bind(this));
        },

        get supportsPlay() {
           return true;
        },

        play: function () {
            if (this.player) {
                this.player.play();
            } else {
                this.pending.play = true;
            }
        },

        mute: function () {
            if (this.player) {
                setTimeout(function () {
                    this.player.setMuted(true);
                }.bind(this), 0);
            } else {
                this.pending.mute = true;
            }
        },

        unmute: function() {
            if (this.player) {
                setTimeout(function () {
                    this.player.setMuted(false);
                }.bind(this), 0);
            } else {
                this.pending.mute = false;
            }
        },

        destroy: function() {
            if (this.player) {
                this.player.removeEventListener('end', this._onDailyMotionEnd);
                this.player.removeEventListener('apiready', this._onPlayerReady);
                this.player = null;
            }
        },

        get isMuted() {
            return this.player ? this.player.muted : this.pending.mute;
        },

        /** @return {number} */
        get playerWidth() {
            return this.$element.find('iframe').width();
        },

        /** @return {number} */
        get playerHeight() {
            return this.$element.find('iframe').height();
        },

        /** @private */
        _postInit: function () {
            var $dmPlayer = this.$element.find('#dmPlayer');

            // Change id to avoid duplicates
            var newPlayerId = 'top-video-dm-' + this.uid;
            $dmPlayer.prop('id', newPlayerId);

            var videoId = $dmPlayer.data('video-id');
            var autoplay = $dmPlayer.data('autoplay');
            var pbskey = $dmPlayer.data('pbskey');
            var params = {autoplay: autoplay};

            if (pbskey) {
                params.ads_params = 'pbskey=' + pbskey;
            }

            this.player = DM.player($dmPlayer[0], {
                video: videoId,
                params: params
            });

            this.player.addEventListener('end', this._onDailyMotionEnd);
            this.player.addEventListener('apiready', this._onPlayerReady);
        },

        /** @private */
        _onDailyMotionEnd: function() {
            this._notifyEnded();
        },

        /** @private */
        _onPlayerReady: function() {
            this._applyState();
            this._notifyReady();
        },

        _applyState: function () {
            if (this.pending.play) {

                this.play();
            }

            if (this.pending.mute) {
                this.mute();
            }

            this.pending.play = false;
            this.pending.mute = false;
        },

        /** @private */
        _notifyEnded: function () {
            this.$element.triggerHandler('ended');

            this.onEnded.forEach(function (callback) {
                callback(this);
            });
        },

        /** @private */
        _notifyReady: function () {
            this.onReady.forEach(function (callback) {
                callback(this);
            });
        }
    };
})(jQuery);
